import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Lesson planning was consuming my entire Sunday. With this 6-in-1 system I reclaimed my weekends completely. The class structures flow beautifully and my students have noticed a huge difference in quality.',
  author: 'Grace M.',
  role: 'Dance Instructor',
  location: 'London, UK'
}, {
  text: 'The Cueing Handbook and the Class Themes Book changed everything for me. I used to freeze mid-class not knowing what to say. Now I walk in with total confidence. This pack is worth 10 times its price.',
  author: 'Sarah L.',
  role: 'Studio Owner',
  location: 'New York, USA'
}, {
  text: 'I teach jazz, contemporary and hip hop and this system works perfectly for all three. The Movement Library alone saved me hours every week. Absolutely worth every penny.',
  author: 'Melissa R.',
  role: 'Freelance Dance Teacher',
  location: 'Sydney, Australia'
}, {
  text: 'As a dance fitness instructor I was struggling to create classes that felt structured and fun at the same time. DANCE READY™ gave me the exact framework I needed. My retention rates have improved dramatically.',
  author: 'Jordan K.',
  role: 'Dance Fitness Instructor',
  location: 'Toronto, Canada'
}, {
  text: "I've been teaching ballet and contemporary for 8 years and was feeling completely stuck. DANCE READY™ gave me my spark back. The progressive programs are a lifesaver for my end-of-year showcases!",
  author: 'Amanda C.',
  role: 'Ballet & Contemporary Teacher',
  location: 'Chicago, IL'
}];
export function Testimonials() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-cream border-y-4 border-brand-beige" data-id="element-156">
      <div className="text-center mb-4" data-id="element-157">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-158">
          WHAT YOUR COLLEAGUES ARE SAYING
        </h2>
        <p className="text-sm font-subheading font-bold text-brand-rose uppercase tracking-wide" data-id="element-159">
          Testimonials from professionals
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-160">
        {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-beige p-3 rounded shadow-sm" data-id="element-161">
            <div className="flex gap-0.5 mb-1.5" data-id="element-162">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-163" />)}
            </div>
            <p className="text-brand-taupe font-medium mb-2 leading-tight italic text-xs sm:text-sm" data-id="element-164">
              "{t.text}"
            </p>
            <div className="border-t border-brand-beige pt-2 flex items-center gap-2" data-id="element-165">
              <div className="w-8 h-8 rounded-full bg-brand-rose/20 flex items-center justify-center text-brand-rose font-bold text-sm border border-brand-rose/30" data-id="element-166">
                {t.author.charAt(0)}
              </div>
              <div className="leading-none" data-id="element-167">
                <p className="font-bold text-brand-taupe text-xs" data-id="element-168">
                  — {t.author}
                </p>
                <p className="text-[10px] text-brand-taupe/70 font-bold uppercase tracking-wide mt-0.5" data-id="element-169">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}